import React, { useState } from 'react'
import { Button, Label, TextInput, Textarea, Card } from 'flowbite-react'
import Nav from './Nav'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ArticleSubmissionForm() {
  const [formData, setFormData] = useState({
    title: '',
    deadline: '',
    description: '',
    email: ''
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formattedData = {
        ...formData,
        deadline: new Date(formData.deadline).toISOString(), // Convert to ISO 8601 string
      };
  
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/listings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formattedData),
      });

      const result = await response.json();
      console.log('the result', result)
      if (response.ok) {
        toast.success('Query added successfully!');
      } else {
        toast.error(result.message || 'An error occurred. Please try again.');
      }

      // Reset form after submission
      setFormData({ deadline: '', pitch: '', email: '', title: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Something went wrong. Please try again.', {
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
            <ToastContainer />
      <header>
        <Nav />
      </header>
      <main className="flex-grow container mx-auto p-4">
        
        <Card className="max-w-md mx-auto">
          
          <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            Submit Your Query
          </h5>
          <p className="font-normal text-gray-700 dark:text-gray-400">
          <p> Submit your query to experts. </p>
          </p>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="deadline" value="Deadline" />
              </div>
              <TextInput
                id="deadline"
                type="date"
                name="deadline"
                value={formData.deadline}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="title" value="Title" />
              </div>
              <TextInput
                id="title"
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter a brief title for your article"
                required
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="pitch" value="Description" />
              </div>
              <Textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Briefly describe what your article is about..."
                required
                rows={4}
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="email" value="Email" />
              </div>
              <TextInput
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
            </div>
            <Button color="blue" type="submit">
              Submit Article
            </Button>
          </form>
        </Card>
      </main>
      <footer className="px-4 bg-white rounded-lg shadow mt-auto dark:bg-gray-800">
        <div className="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
          <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
            © 2024 <a href="https://flowbite.com/" className="hover:underline">PressRequest</a>. All Rights Reserved.
          </span>
          <ul className="flex flex-wrap items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0">
          <li>
            <a href="mailto:sethking@pressrequest.io" className="hover:underline" target="_blank" rel="noopener noreferrer">
              Contact
            </a>
          </li>
          </ul>
        </div>
      </footer>
    </div>
  )
}

export default ArticleSubmissionForm
